export const DOB_INPUT_ATTRS = () => {
  const [day, month, year] = new Date().toLocaleDateString('en-IE').split('/');
  return {
    'date-max': new Date(year - 18, month - 1, day).getTime(),
    'date-min': new Date(year - 110, month - 1, day).getTime()
  };
};

export const YEAR_CONSTRUCTED_INPUT_ATTRS = () => {
  const year = new Date().getFullYear();
  return {
    field: 'year_building_constructed',
    options: {
      only_integer: true,
      less_than_or_equal_to: year,
      greater_than_or_equal_to: year - 100
    }
  };
};
